require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-value-of-remote-work.json") })
        }
      }, "path---blog-the-value-of-remote-work");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-value-of-remote-work!./.cache/json/blog-the-value-of-remote-work.json
// module id = 1116
// module chunks = 231608221292675